import * as React from 'react'

import { FormSection } from 'main/components/common/Form'
import { TextField } from 'main/ui'
import { IParams, IValidation } from '../types'

interface IProps {
  params: IParams
  validation: IValidation
  onChange: (params: Partial<IParams>) => void
}

export default function Fields(props: IProps) {
  const { params, validation, onChange } = props

  return (
    <FormSection widthConstraint={false}>
      <TextField
        label="First name"
        placeholder="Enter your first name"
        value={params.firstName}
        onChange={firstName => onChange({ firstName })}
        validationHint={validation.firstName}
        required
      />
      <TextField
        label="Email"
        placeholder="Enter your email"
        value={params.email}
        onChange={email => onChange({ email })}
        validationHint={validation.email}
        required
      />
    </FormSection>
  )
}
